module.exports = __webpack_public_path__ + "static/media/favicon.2cc53f6e.ico";